import {useCustomQuery} from "~/query/queryClient";
import {queryHttp} from "~/query/queryHttp";
import {supplierContactListUrl} from "~/pages/supplier-360/services/supplier360Urls";
import type {SupplierContact} from "~/pages/supplier-360/types/Supplier360Types";

/**
 * Every contact of one entity in one call — the Identity section's three multi-selects split it
 * by `contact_type` client-side (docs §2.23, §3.3), rather than fetching each type separately.
 */
export function useSupplierContactsQuery(entityId: number | undefined) {
    const url = supplierContactListUrl(entityId ?? 0);
    return useCustomQuery({
        queryKey: [url] as const,
        queryFn: async () => (await queryHttp.get<SupplierContact[]>(url)).data,
        enabled: Boolean(entityId),
    });
}
